/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".infomodal[_ngcontent-%COMP%]{--padding-end:4.16vh;--padding-start:4.16vh}.infomodal--header[_ngcontent-%COMP%]{margin-top:4.4vh;margin-bottom:5.8vh}.infomodal--content[_ngcontent-%COMP%]{margin-bottom:3.6vh;padding:0 4.4vh}.infomodal--content[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0;font-size:4vh}"];
export { styles as styles };
